import { render, staticRenderFns } from "./ModalProductionAreas.vue?vue&type=template&id=d54179b2&lang=pug&"
import script from "./ModalProductionAreas.vue?vue&type=script&lang=js&"
export * from "./ModalProductionAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports